module.exports = __webpack_public_path__ + "static/img/IMG_20241208_165335.bf480fc8.jpg";